import styled from "styled-components"
import PageTopTitle from "../shared/PageTopTitle"
import { useDispatch, useSelector } from "react-redux"
import InputGroup from "../shared/InputGroup"
import { useEffect, useState } from "react"
import { showModal } from "../../features/modal/modalSlice"
import Button from "../shared/Button"
import { useScrollLock } from "../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import { updateEgeyurtIletisimItem } from "../../features/admin/adminSlice"
import Btn from "../shared/button/Btn"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 870px;
        max-width: 800px;
        height: 350px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .form{
            margin-top: 40px;
            display: flex;
            width: 100%;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            height:570px;
            padding-bottom: 30px;
            overflow: auto;
        }

        .btn-group{
            padding: 20px;
            display: flex;
            gap: 30px;
        }
    }
    `
const UpdateEgeyurtIletisimItemModal = () => {
    const { egeyurtIletisimItemData} = useSelector(state => state.admin)
    const {modalLocation} = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [data, setData] = useState(egeyurtIletisimItemData)
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [message, setMessage] = useState("")
    const dispatch = useDispatch()
    const location = useLocation()
    const handleChange = (e) => {
        setData((prev)=> ({...prev, [e.target.name]: e.target.value}))

    }

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    useEffect(()=> {
        if(isSubmitted){
            if(!data.tittle || !data.phoneNumber){
                setMessage("Lütfen zorunlu alanları doldurun.")
            }
            else{
                setMessage("")
            }
        }
    },[isSubmitted, data.tittle, data.phoneNumber])


    const requiredFields = ["tittle", "phoneNumber"]

    const handleSubmit = () => {
        setIsSubmitted(true)
        if(!data.tittle || !data.phoneNumber){
            setMessage("Lütfen zorunlu alanları doldurun.")
        }
        else{
            setMessage("")
            dispatch(updateEgeyurtIletisimItem(data))
        }
    }
    
  return (
    <ModalContainer onClick={()=>dispatch(showModal(null))}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <PageTopTitle title={"Egeyurt İletişim Bilgisi Düzenle"}/>
            <div className="form">
                <InputGroup handleChange={handleChange} isRequired={true} labelText={"Başlık"} value={data.tittle} inputType={"text"} name={"tittle"} labelWidth={"270px"} inputWidth={"370px"} isSubmitted={isSubmitted} requiredFields={requiredFields} />
                <InputGroup handleChange={handleChange} isRequired={true} labelText={"Telefon Numarası"} value={data.phoneNumber} inputType={"text"} name={"phoneNumber"} labelWidth={"270px"} inputWidth={"370px"} isSubmitted={isSubmitted} requiredFields={requiredFields} />
            </div>
            {message &&
            <div>{message}</div>
            }
            <div className="btn-group">
                <Btn color={"#E85446"} background={"transparent"} width="160px" handleClick={handleSubmit}>Güncelle</Btn>
                <Btn color={"#E85446"} background={"transparent"} width="160px" handleClick={()=> dispatch(showModal("deleteEgeYurtIletisimBirim"))}>Sil</Btn>
                <Btn color={"#E85446"} background={"transparent"} width="160px" handleClick={()=> dispatch(showModal(null))}>İptal</Btn>
            </div>
        </div>
    </ModalContainer>

  )
}

export default UpdateEgeyurtIletisimItemModal